import { createContext } from 'react';
import _noop from 'lodash/noop';

// We create the initial context with no-ops so that its type matches the eventual value.
export const ToastContext = createContext<ToastProviderValue>({
    add: _noop,
    remove: _noop,
});
